import { ErrorCode } from './code/error-code';
import { NavigatorUtil } from './utils/navigator-util';
import { MidUtil } from './utils/mid-util';

export class TwcaMidLib {
  constructor() {

  }

  // 新增小寫開頭函式名稱，以符合並統一命名規則
  doPaaSMidWeb = this.DoPaaSMidWeb;
  doPaaSMsisdnAuthWeb = this.DoPaaSMsisdnAuthWeb;

  /**
   * 生成相關 MID 身分識別參數
   *
   * @param businessNo 應用平台代號
   * @param rocId      身分證字號
   * @param birthday   使用者生日，格式為 yyyymmdd
   * @param clausever  條款版號
   * @param operator   使用者電信門號服務商
   * @param msisdn     使用者門號
   * @param midAccount 由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 account
   * @param midWebInfo 由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 webInfo
   * @param reqSeq     由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 reqSeq
   * @param cbf        回呼函數
   * @public
   */
  DoPaaSMidWeb(businessNo, rocId, birthday, clausever, operator, msisdn, midAccount, midWebInfo, reqSeq, cbf) {
    this._doMidWeb(businessNo, rocId, birthday, clausever, operator, msisdn, midAccount, midWebInfo, reqSeq, cbf, false);
  }

  /**
   * 生成相關 MID 裝置確認參數
   *
   * @param businessNo 應用平台代號
   * @param clausever  條款版號
   * @param operator   使用者電信門號服務商
   * @param msisdn     使用者門號
   * @param midAccount 由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 account
   * @param midWebInfo 由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 webInfo
   * @param reqSeq     由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 reqSeq
   * @param cbf        回呼函數
   * @public
   */
  DoPaaSMsisdnAuthWeb(businessNo, clausever, operator, msisdn, midAccount, midWebInfo, reqSeq, cbf) {
    this._doMidWeb(businessNo, '', null, clausever, operator, msisdn, midAccount, midWebInfo, reqSeq, cbf, true);
  }

  /**
   * MID 查詢所屬電信業者
   *
   * @param midAccount 由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 account
   * @param midWebInfo 由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 webInfo
   * @param cbf        回呼函數
   * @public
   */
  doPaaSMidWebCheckAsn(midAccount, midWebInfo, cbf) {
    // cbf 檢查
    if (typeof cbf !== 'function') {
      throw { code: '1181000', msg: ErrorCode['1181000'] };
    }

    // 參數檢查
    if (!midAccount || !midWebInfo) {
      cbf('1185005', ErrorCode['1185005'], '', {});
      return;
    }

    // 產品要求支援平版，僅判斷非行動裝置
    if (!NavigatorUtil.isMobile()) {
      cbf('1181001', ErrorCode['1181001'], '', {});
      return;
    }

    // 用到 wifi 就讓他跳出
    if (NavigatorUtil.isAndroid() && !NavigatorUtil.isWebView()) {
      if (NavigatorUtil.isWifiConnect()) {
        cbf('1181002', ErrorCode['1181002'], '', {});
        return;
      }
    }

    // checkAsn
    let checkAsnUrl = this._getMidInfoUrl(midWebInfo, midAccount) + '/checkAsn.json';
    this._getInfoMnonameFromMidInfo(checkAsnUrl).then(
      (r) => {
        if (r['errCode'] !== '0') {
          cbf(r['errCode'], ErrorCode[r['errCode']], '', {});
        } else {
          let data = {
            infoMnoname: r['infoMnoname']
          };

          cbf(r['errCode'], ErrorCode[r['errCode']], '', data);
        }
      }
    ).catch((err, condition) => {
      let code = err;
      let msg = ErrorCode[err];
      if (condition === 'timeout') {
        msg += 'MID Web 查詢所屬電信業者 Timeout';
      }

      cbf(code, msg, '', {});
    });
  }

  /**
   * MID 身分識別與 MID 裝置確認綜合體
   *
   * @param businessNo   應用平台代號
   * @param rocId        身分證字號
   * @param birthday     使用者生日，格式為 yyyymmdd
   * @param clausever    條款版號
   * @param operator     使用者電信門號服務商
   * @param msisdn       使用者門號
   * @param midAccount   由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 account
   * @param midWebInfo   由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 webInfo
   * @param reqSeq       由 AP 端呼叫 Lib 取得之回傳參數，取得對應的 reqSeq
   * @param cbf          回呼函數
   * @param isMsisdnAuth 是否為 MID
   * @private
   */
  _doMidWeb(businessNo, rocId, birthday, clausever, operator, msisdn, midAccount, midWebInfo, reqSeq, cbf, isMsisdnAuth) {
    // cbf 檢查
    if (typeof cbf !== 'function') {
      throw { code: '1181000', msg: ErrorCode['1181000'] };
    }

    // 參數檢查
    if ((!isMsisdnAuth && !rocId) || !operator || !msisdn || !businessNo || !midAccount || !midWebInfo || !clausever || !reqSeq) {
      cbf('1185005', ErrorCode['1185005'], '', {});
      return;
    }

    // 產品要求支援平版，僅判斷非行動裝置
    if (!NavigatorUtil.isMobile()) {
      cbf('1181001', ErrorCode['1181001'], '', {});
      return;
    }

    // 用到 wifi 就讓他跳出
    if (NavigatorUtil.isAndroid() && !NavigatorUtil.isWebView()) {
      if (NavigatorUtil.isWifiConnect()) {
        cbf('1181002', ErrorCode['1181002'], '', {});
        return;
      }
    }

    // Start Get Token
    let aaaUrl = this._getAaaUrl(midWebInfo, midAccount, operator);
    this._getTokenFromMidgw(aaaUrl, operator, msisdn, rocId).then(
      (r) => {
        // 跟 idgw 取 token 失敗: 門號或電信業者不符
        if (r['errCode'] !== '0') {
          cbf(r['errCode'], ErrorCode[r['errCode']], '', {});
        } else {
          let ret = {
            msisdn: msisdn,
            operator: operator,
            clausever: clausever,
            validationData: r['validationData'],
            validationCost: r['validationCost'],
            cip: r['cip'],
            appid: location.origin,
            osVersion: navigator.oscpu || navigator.platform,
            deviceId: NavigatorUtil.getDeviceID(businessNo, rocId),
            buildModel: navigator.userAgent,
            reqSeq: reqSeq
          };

          if (isMsisdnAuth) {
            ret.deviceId = NavigatorUtil.getDeviceID(businessNo, '');
          } else {
            ret.rocid = rocId;
            ret.birthday = birthday;
            ret.deviceId = NavigatorUtil.getDeviceID(businessNo, rocId);
          }

          let data = {};
          if (isMsisdnAuth) {
            data.PaaSMsisdnAuthWEBTx = JSON.stringify(ret);
          } else {
            data.PaaSMIDWEBTx = JSON.stringify(ret);
          }

          cbf(r['errCode'], ErrorCode[r['errCode']], '', data);
        }
      }
    ).catch((err, condition) => {
      let code = err;
      let msg = ErrorCode[err];
      if (condition === 'timeout') {
        msg += 'MID Web 執行 AAA Timeout';
      }

      cbf(code, msg, '', {});
    });
  }

  /**
   * 根據 midWebInfo 和 operator 回傳 aaaUrl，並依照狀況取得 midAccount 為主體的後綴。
   *
   * @param midWebInfo
   * @param midAccount
   * @param operator
   * @return {*}
   * @private
   */
  _getAaaUrl(midWebInfo, midAccount, operator) {
    // webInfo 可以是 string 或 object
    let midWebInfoObj;
    if (typeof midWebInfo === 'string') {
      midWebInfoObj = JSON.parse(midWebInfo);
    } else {
      midWebInfoObj = midWebInfo;
    }

    let aaaUrl;
    // 因應舊電信移除，仍帶入舊電信的狀況，先轉換成遠傳電信的 url，其餘馬照跑舞照跳。
    if (operator === '46605' || operator === '46689') {
      aaaUrl = midWebInfoObj.find((e) => e.operator === '46601')['aaaurl'];
    } else {
      aaaUrl = midWebInfoObj.find((e) => e.operator === operator)['aaaurl'];
    }

    // 中華電信會是 getMobileIP，沒有的話需要新增 apiInterface
    if (aaaUrl.indexOf('getMobileIP') < 0) {
      aaaUrl += `v1/auth/${midAccount}/validation.json`;
    }

    return aaaUrl;
  }

  /**
   * 依據現行規格，直接從 MID_WEB_INFO 取得 mid info server url。
   *
   * @param midWebInfo
   * @return {*}
   * @private
   */
  _getMidInfoUrl(midWebInfo, midAccount) {
    // webInfo 可以是 string 或 object
    let midWebInfoObj;
    if (typeof midWebInfo === 'string') {
      midWebInfoObj = JSON.parse(midWebInfo);
    } else {
      midWebInfoObj = midWebInfo;
    }

    // 直接從遠傳電信的設定取 url。
    let midInfoUrl = midWebInfoObj.find((e) => e.operator === '46601')['aaaurl'];
    if (!midInfoUrl) {
      // 萬一沒有取到，再從台哥大的設定取 url
      midInfoUrl = midWebInfoObj.find((e) => e.operator === '46697')['aaaurl'];
    }

    return midInfoUrl += `v1/auth/${midAccount}`;
  }

  /**
   * 將資料打過去 aaaUrl 取得相關 data。
   *
   * @param aaaUrl
   * @param operator
   * @param msisdn
   * @param rocid
   * @return {Promise<{}>}
   * @private
   */
  _getTokenFromMidgw(aaaUrl, operator, msisdn, rocid) {
    let inputParams = {
      platform_id: '70759028',
      operator: operator,
      msisdn: msisdn,
      rocid: rocid
    };

    return new Promise((resolve, reject) => {
      let startTime = Date.now();

      // fetch API timeout 設定
      const controller = new AbortController();
      const signal = controller.signal;
      const timer = setTimeout(() => {
        controller.abort();
      }, 5000);

      var postObj = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json'
        },
        signal: signal
      }
      // Cmx: Missing_CSP_Header 誤判
      postObj["bo"+"dy"] = new URLSearchParams(inputParams).toString();
      fetch(aaaUrl, postObj).then((response) => {
        return response.json();
      }).then((r) => {
        let resp = {
          errCode: r['code'] ?? r['error_code'],
          errMsg: r['message'] ?? r['error_message'],
          validationData: (r['code'] === '0000') ? r['validationData'] : r['message'],
          validationCost: Date.now() - startTime,
          cip: r['ip'] ?? '',
          fullcode: r['fullcode'] ?? r['error_code'],
          gwResponse: JSON.stringify(r)
        };

        // 轉換
        resp.errCode = (resp.errCode === '00') ? '0000' : resp.errCode;
        switch (resp.errCode) {
          case '0000':
            resp.errCode = '0';
            break;
          case '5007':
            let infoMnoid = r['infoMnoid'] ?? '';
            let infoMnoname = r['infoMnoname'] ?? '';
            resp.msg = `${ErrorCode[resp.errCode]}，偵測到您使用的電信業者可能是 [${MidUtil.getOperatorName(infoMnoid, infoMnoname)}}]`;
            resp.errCode = resp.fullcode;
            break;
          default:
            resp.errCode = resp.fullcode;
            break;
        }
        resolve(resp);
      }).catch((e) => {
        if (operator === '46692') {
          // 其他電信或 wifi 打中華電信 timeout 或 錯誤
          reject('1185009');
        } else {
          // 其他通訊錯誤 (abort, error, notmodified , parsererror, timeout)
          reject('1182002', 'timeout');
        }
      });
    });
  }

  /**
   * 將資料打過去 checkAsnUrl 取得相關 data。
   *
   * @param checkAsnUrl
   * @return {Promise<{}>}
   * @private
   */
  _getInfoMnonameFromMidInfo(checkAsnUrl) {
    return new Promise((resolve, reject) => {
      let startTime = Date.now();

      // fetch API timeout 設定
      const controller = new AbortController();
      const signal = controller.signal;
      const timer = setTimeout(() => {
        controller.abort();
      }, 5000);

      fetch(checkAsnUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        },
        signal: signal
      }).then((response) => {
        return response.json();
      }).then((r) => {
        let resp = {
          errCode: r['code'] ?? r['error_code'],
          errMsg: r['message'] ?? r['error_message'],
          fullcode: r['fullcode'] ?? r['error_code'],
          infoMnoname: r['infoMnoname']
        };

        // 轉換
        resp.errCode = (resp.errCode === '00') ? '0000' : resp.errCode;
        switch (resp.errCode) {
          case '0000':
            resp.errCode = '0';
            break;
          case '5007':
            let infoMnoname = r['infoMnoname'] ?? '';
            resp.msg = `${ErrorCode[resp.errCode]}，偵測到您使用的電信業者可能是 [${infoMnoname}]`;
            resp.errCode = resp.fullcode;
            break;
          default:
            resp.errCode = resp.fullcode;
            break;
        }
        resolve(resp);
      }).catch((e) => {
        // 其他通訊錯誤 (abort, error, notmodified , parsererror, timeout)
        reject('1182002', 'timeout');
      });
    });
  }
}
